<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div>
            <div v-if="loading">
              <div class="ba-flex ba-items-center ba-justify-center">
                <div class="ba-text-6xl ba-flex-shrink-0 ba-mr-6">
                  <span class="far fa-spinner fa-spin" />
                </div>
                <div class="ba-text-sm">
                  <h4>{{ $t("userIdentification") }}</h4>
                </div>
              </div>
            </div>
            <div v-else-if="error">
              <div class="ba-flex ba-items-center ba-justify-center">
                <div class="ba-text-6xl ba-flex-shrink-0 ba-mr-6">
                  <span class="far fa-exclamation-circle" />
                </div>
                <div class="ba-text-sm">
                  <h4>{{ $t("userIdentificationError") }}</h4>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import visaryApi from "@/api/visary-api";
import rhmApi from "@/api/rhm-api";
import profileApi from "@/api/profile-api";
import RemoteCrudService from "@/shared/services/remote-crud-service";
import globalState from "@/shared/global-state";
import log from "@/shared/log";
import { HEAD_STUFF_CATEGORY_IDS } from '@/shared/enum/user-catigories';

const EMPLOYEE_MNEMONIC_NAME = 'employee';

export default {
  name: "vis-load-user-config",
  data() {
    return {
      loading: false,
      error: false
    };
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    if (this.$_cancelSources) {
      this.$_cancelSources.cancel(
        "Operation is canceled because component destroyed"
      );
    }
  },
  methods: {
    async fetchData() {
      try {
        if (!this.$_cancelSources) {
          this.$_cancelSources = visaryApi.cancel.sources();
        }

        this.loading = true;

        await this.setCurrentUser();
        await this.addStaffingData();

        if (globalState.currentUser.IsEmployee) {
          await this.getPositionData();
        } else {
          await this.getCorrespondent();
        }

        await this.fetchWorkflowConfig();

        this.$emit("loaded");
      } catch (e) {
        log.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    async fetchWorkflowConfig() {
      this.setWorkflowConfig(
        await visaryApi.workflow.getConfig(this.$_cancelSources.token())
      );
    },
    async getGroupsData() {
      const { ID } = globalState.currentUser;

      if (!ID) return;

      try {
        const groupsData = await profileApi.user.getUserGroups(ID);

        globalState.currentUser.groupsData = groupsData
      } catch (e) {}
    },
    async getPositionData() {
      const crudService = new RemoteCrudService(EMPLOYEE_MNEMONIC_NAME);
      const { ID } = globalState.currentUser;

      if (!ID) return;

      crudService.setId(ID)

      try {
        const { Department, Position } = await crudService.get()

        globalState.currentUser.employeeData = { Department, Position }

        await this.getGroupsData();
      } catch(e) {
        await this.getCorrespondent()
      }
    },
    async getCorrespondent() {
      const { ID } = globalState.currentUser;

      if (!ID) return;

      try {
        const correspondentData = await visaryApi.user.getConnespondentRecord(ID)
        globalState.currentUser.Correspondent = correspondentData.Correspondent
      } catch(e) {}
    },
    async setCurrentUser() {
      globalState.currentUser = await visaryApi.user.getCurrent(this.$_cancelSources.token())
      globalState.currentUser.isHeadStaff = globalState.currentUser.Categories && HEAD_STUFF_CATEGORY_IDS.includes(globalState.currentUser.Categories[0])
    },
    setWorkflowConfig(workflowConfig) {
      globalState.workflowConfig = workflowConfig;
    },
    async addStaffingData() {
      const { ID } = globalState.currentUser;

      if (!ID) return;

      try {
        const res = await rhmApi.staffing.getStaffingExt(ID);

        const { IsManager, IsOperator, IsSupervisor, IsModerator, IsSupportTeam } = res;

        globalState.currentUser.IsEmployee = true;
        globalState.currentUser.IsManager = IsManager;
        globalState.currentUser.IsOperator = IsOperator;
        globalState.currentUser.IsSupervisor = IsSupervisor;
        globalState.currentUser.IsModerator = IsModerator;
        globalState.currentUser.IsSupportTeam = IsSupportTeam;
        globalState.currentUser.staffId = res.ID;
      } catch (e) {
        globalState.currentUser.IsEmployee = globalState.currentUser.IsAdmin
        console.warn(e);
      }
    }
  }
};
</script>
